import React from "react";
import adaptiveTest from "./data";
import { upcomingSlots, todayInIST, formatFee } from "./schedule";
import AdaptiveTestCard from "./AdaptiveTestCard";

// Join Us → "Adaptive Test" tab: intro, fee and Energia credit lines, then one card per date + centre + slot.
// Props exist only so tests can pass fixed content and a fixed "today".
const AdaptiveTestCards = ({ content = adaptiveTest, today = todayInIST() }) => {
  const entries = upcomingSlots(content.sessions, today);
  return (
    <>
      {content.intro && <p className="mt-4 mb-2" style={{ fontSize: "17px" }}>{content.intro}</p>}
      <p className={content.intro ? "mb-0" : "mt-4 mb-0"} style={{ fontSize: "17px" }}>
        <b>Fee:</b> {formatFee(content.fee)}
      </p>
      <p className="mb-0" style={{ fontSize: "17px" }}>{content.conductedBy}</p>
      {entries.length === 0 ? (
        <center style={{ color: "red", fontSize: "19px", fontWeight: "500" }}>
          <p>New dates coming soon</p>
        </center>
      ) : (
        <div className="row">
          {entries.map((entry) => (
            <AdaptiveTestCard key={`${entry.date}-${entry.name}-${entry.slot}`} entry={entry} />
          ))}
        </div>
      )}
    </>
  );
};

export default AdaptiveTestCards;
